import {
  // setUser,
  // setInvitationUser,
  addInvitationUser,
  removeUser,
  removeInvitation,
  updateUser,
  updateInvitation,
} from "stores/slice/bogus/userManagement/org/const";

const orgUserManagementConfig = {
  // List Org Users
  "/ents/:entId/orgs/:orgId/users.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/users",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.users",
  },
  "/orgs/:orgId/users.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/users",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.users",
  },
  // Get Org User Details
  "/ents/:entId/orgs/:orgId/users/:userId.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/users/:userId",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.users",
  },
  "/orgs/:orgId/users/:userId.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/users/:userId",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.users",
  },
  // List Pending Org Invitations
  "/ents/:entId/orgs/:orgId/invitations.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/invitations",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.invitations",
  },
  "/orgs/:orgId/invitations.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/invitations",
    restful: true,
    method: "read",
    action: null,
    mockSelector: "orgUserManagement.invitations",
  },

  // Remove an Org User
  "/ents/:entId/orgs/:orgId/users/:userId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/users/:userId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({
      entId: params.entId,
      orgId: params.orgId,
      userId: params.userId,
    }),
    action: removeUser,
    mockSelector: "orgUserManagement.users",
  },
  "/orgs/:orgId/users/:userId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/users/:userId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ orgId: params.orgId, userId: params.userId }),
    action: removeUser,
    mockSelector: "orgUserManagement.users",
  },
  // Cancel an Org Invitation
  "/ents/:entId/orgs/:orgId/invitations/:invitationId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/invitations/:invitationId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({
      entId: params.entId,
      orgId: params.orgId,
      invitationId: params.invitationId,
    }),

    action: removeInvitation,
    mockSelector: "orgUserManagement.invitations",
  },
  "/orgs/:orgId/invitations/:invitationId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/invitations/:invitationId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({
      orgId: params.orgId,
      invitationId: params.invitationId,
    }),
    action: removeInvitation,
    mockSelector: "orgUserManagement.invitations",
  },

  // Create an Org Invitation
  "/ents/:entId/orgs/:orgId/invitations.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/invitations",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: addInvitationUser,
    mockSelector: "orgUserManagement.invitations",
  },
  "/orgs/:orgId/invitations.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/invitations",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: addInvitationUser,
    mockSelector: "orgUserManagement.invitations",
  },

  // Update an Org User
  "/ents/:entId/orgs/:orgId/users/:userId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/users/:userId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateUser,
    mockSelector: "orgUserManagement.users",
  },
  "/orgs/:orgId/users/:userId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/users/:userId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateUser,
    mockSelector: "orgUserManagement.users",
  },

  // Update an Org Invitation
  "/ents/:entId/orgs/:orgId/invitations/:invitationId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/invitations/:invitationId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateInvitation,
    mockSelector: "orgUserManagement.invitations",
  },
  "/orgs/:orgId/invitations/:invitationId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/invitations/:invitationId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateInvitation,
    mockSelector: "orgUserManagement.invitations",
  },

  // Resend an Org Invitation
  "/ents/:entId/orgs/:orgId/invitations/:invitationId/resend.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/invitations/:invitationId/resend",
    restful: true,
    method: "update",
    action: null,
    mockSelector: "orgUserManagement.invitations",
  },
  "/orgs/:orgId/invitations/:invitationId/resend.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/invitations/:invitationId/resend",
    restful: true,
    method: "update",
    action: null,
    mockSelector: "orgUserManagement.invitations",
  },
};

export default orgUserManagementConfig;
